module.exports = __webpack_public_path__ + "img/bottle_test.ac7e1b5d.jpg";